module.exports = __webpack_public_path__ + "img/users.a2622562.svg";